import React, { useState, useEffect } from 'react';
import './Splash.css';
import { Redirect } from 'react-router-dom';
import Logo from '../../components/Logo/Logo';

const AnimatedSplash = () => {
  return (
    <div className='logo_wrapper'>
      <div className='screen'>
        <Logo id='logo' />
      </div>
    </div>
  );
};

const Splash = () => {
  const [redirect, setRedirect] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setRedirect(true);
    }, 6500);
    return () => clearTimeout(timer);
  }, []);

  return redirect ? <Redirect to='/home' /> : <AnimatedSplash />;
};

export default Splash;
